{
  "tabs": {
    "chat": "चैट",
    "reminders": "रिमाइंडर",
    "calendar": "कैलेंडर",
    "settings": "सेटिंग्स"
  },
  "common": {
    "cancel": "रद्द करें",
    "save": "सहेजें",
    "confirm": "पुष्टि करें",
    "delete": "हटाएं",
    "back": "पीछे",
    "close": "बंद करें",
    "edit": "संपादित करें",
    "search": "खोजें",
    "all": "सभी",
    "loading": "लोड हो रहा है...",
    "error": "कुछ गलत हो गया",
    "notFound": "मिला नहीं",
    "tryAgain": "कृपया पुनः प्रयास करें",
    "retry": "पुनः प्रयास करें",
    "undo": "पूर्ववत करें",
    "pullToRefresh": "ताज़ा करने के लिए खींचें",
    "justNow": "अभी-अभी"
  },
  "auth": {
    "welcome": "FishMemory में आपका स्वागत है",
    "tagline": "आपका WhatsApp रिमाइंडर सहायक, अब आपकी जेब में।",
    "subtitle": "आपका WhatsApp रिमाइंडर सहायक, अब आपकी जेब में।",
    "phoneLabel": "आपका WhatsApp नंबर",
    "phoneHint": "हम WhatsApp के जरिए सत्यापन कोड भेजेंगे",
    "invalidPhone": "कृपया मान्य फोन नंबर दर्ज करें",
    "continue": "जारी रखें",
    "enterPhone": "अपना WhatsApp नंबर दर्ज करें",
    "phonePlaceholder": "फोन नंबर",
    "sendCode": "कोड भेजें",
    "verifyTitle": "अपना नंबर सत्यापित करें",
    "otpSentTo": "6-अंकों का कोड {{phone}} पर WhatsApp से भेजा गया है",
    "enterFullCode": "कृपया सभी 6 अंक दर्ज करें",
    "invalidOtp": "अमान्य कोड। कृपया पुनः प्रयास करें।",
    "otpFailed": "कोड भेजने में विफल। पुनः प्रयास करें।",
    "otpResent": "कोड पुनः भेजा गया",
    "resendIn": "{{seconds}} सेकंड में पुनः भेजें",
    "resendCode": "कोड पुनः भेजें",
    "enterOtp": "WhatsApp पर भेजा गया कोड दर्ज करें",
    "verify": "सत्यापित करें",
    "resend": "कोड पुनः भेजें",
    "wrongNumber": "गलत नंबर?",
    "backToPhone": "फोन पर वापस जाएं",
    "editPhone": "फोन नंबर संपादित करें",
    "error": "त्रुटि",
    "setupTitle": "सेटअप शुरू करें",
    "setupSubtitle": "आप बाद में सेटिंग्स में इसे बदल सकते हैं",
    "namePlaceholder": "आपका नाम",
    "letsGo": "सेटअप पूरा करें",
    "skipForNow": "अभी छोड़ें"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "संदेश टाइप करें...",
    "inputPlaceholder": "संदेश टाइप करें...",
    "typing": "FishMemory टाइप कर रहा है...",
    "online": "ऑनलाइन",
    "connecting": "कनेक्ट हो रहा है...",
    "reconnecting": "पुनः कनेक्ट हो रहा है...",
    "offline": "ऑफ़लाइन",
    "empty": "बातचीत शुरू करें",
    "emptyHint": "रिमाइंडर बनाएं, अपना शेड्यूल देखें, या मदद मांगें।",
    "emptyAction": "नमूना रिमाइंडर भेजें",
    "actions": "चैट क्रियाएँ",
    "keep": "संदेश रखें",
    "clearTitle": "चैट साफ़ करें",
    "clearConfirm": "क्या आप इस डिवाइस से सभी संदेश हटाना चाहते हैं? यह पूर्ववत नहीं किया जा सकता।",
    "clear": "चैट साफ़ करें",
    "optionSelected": "चयनित: {{label}}",
    "sendingSelection": "भेजा जा रहा है...",
    "connectionLost": "पुनः कनेक्ट हो रहा है..."
  },
  "reminders": {
    "title": "मेरे रिमाइंडर",
    "active": "सक्रिय",
    "today": "आज",
    "thisWeek": "इस सप्ताह",
    "history": "इतिहास",
    "items": "आइटम",
    "emptyTitle": "कोई रिमाइंडर नहीं",
    "emptySubtitle": "चैट से एक बनाएं और यह यहाँ दिखेगा।",
    "emptyAction": "चैट खोलें",
    "filterActive": "सक्रिय",
    "filterToday": "आज",
    "filterWeek": "इस सप्ताह",
    "filterHistory": "इतिहास",
    "emptyState": "कोई रिमाइंडर नहीं। चैट शुरू करें!",
    "swipeDone": "पूरा हुआ",
    "swipeSnooze": "स्नूज़",
    "swipeDelete": "हटाएं",
    "search": "रिमाइंडर खोजें...",
    "upcoming": "आगामी",
    "completed": "पूरा हुआ",
    "overdue": "मियाद समाप्त",
    "tomorrow": "कल",
    "synced": "सिंक किया गया {{value}}",
    "swipeHint": "अधिक क्रियाओं के लिए रिमाइंडर स्वाइप करें",
    "noResults": "कोई रिमाइंडर मेल नहीं खाता",
    "noResultsHint": "कृपया अलग शब्द खोजें या खोज साफ़ करें",
    "deleteAllFailed": "सभी रिमाइंडर हटाने में विफल"
  },
  "calendar": {
    "title": "कैलेंडर",
    "today": "आज",
    "tomorrow": "कल",
    "completed": "पूरा हुआ",
    "noEvents": "कोई कार्यक्रम नहीं",
    "noEventsSubtitle": "रिमाइंडर और कैलेंडर इवेंट देखने के लिए तारीख चुनें।",
    "googleEvent": "Google कैलेंडर",
    "legendActive": "सक्रिय",
    "legendRecurring": "दोहराव",
    "legendDone": "पूरा हुआ",
    "legendGoogle": "Google",
    "previousMonth": "पिछला महीना",
    "nextMonth": "अगला महीना",
    "previousYear": "पिछला वर्ष",
    "nextYear": "अगला वर्ष",
    "goToToday": "आज पर जाएं",
    "all": "सभी",
    "active": "सक्रिय",
    "done": "पूरा हुआ",
    "paused": "रोक दिया गया"
  },
  "settings": {
    "title": "सेटिंग्स",
    "profile": "प्रोफ़ाइल",
    "name": "प्रदर्शित नाम",
    "enterName": "अपना नाम दर्ज करें",
    "language": "भाषा",
    "uiLanguage": "ऐप भाषा",
    "uiLanguageHelp": "इस डिवाइस पर ऐप UI, कैलेंडर लेबल और लेआउट दिशा बदलता है।",
    "serverLanguage": "चैट भाषा",
    "serverLanguageHelp": "आपके खाते के लिए सर्वर उत्तर और रिमाइंडर संदेशों की भाषा बदलता है।",
    "timezone": "समय क्षेत्र",
    "currentTimezone": "वर्तमान समय क्षेत्र",
    "timezoneHelp": "सभी रिमाइंडर समय इस समय क्षेत्र के अनुसार दिखाए जाते हैं।",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "समय क्षेत्र सहेजें",
    "timezoneSaved": "समय क्षेत्र अपडेट किया गया",
    "detect": "पता लगाएं",
    "detectFailed": "समय क्षेत्र पता नहीं चल सका",
    "autoDetect": "GPS से स्वचालित पता लगाएं",
    "notifications": "सूचनाएं",
    "notificationsHelp": "फॉलो-अप रिमाइंडर डिलीवरी के बाद पुनः अलर्ट नियंत्रित करते हैं। डिवाइस स्तर की अनुमति फोन सेटिंग्स में प्रबंधित होती हैं।",
    "pushEnabled": "पुश सूचनाएं",
    "autoDoneOnFire": "फायर होते ही स्वचालित पूरा करें",
    "autoDoneOnFireDesc": "बंद होने पर, रिमाइंडर तब तक सक्रिय रहते हैं जब तक आप उन्हें पूरा न करें।",
    "googleCalendar": "Google कैलेंडर",
    "google": "Google कैलेंडर",
    "googleConnected": "कनेक्टेड",
    "googleDisconnected": "कनेक्ट नहीं",
    "googleConnectedHelp": "नए रिमाइंडर अपने कैलेंडर से स्वचालित सिंक हो सकते हैं।",
    "googleDisconnectedHelp": "रिमाइंडर और इवेंट को सिंक में रखने के लिए Google कैलेंडर कनेक्ट करें।",
    "googleConnectFailed": "Google कैलेंडर कनेक्ट करने में विफल",
    "connected": "कनेक्टेड",
    "disconnected": "कनेक्ट नहीं",
    "connect": "कनेक्ट करें",
    "disconnect": "डिस्कनेक्ट करें",
    "autoSync": "नए रिमाइंडर ऑटो-सिंक",
    "autosync": "नए रिमाइंडर ऑटो-सिंक",
    "subscription": "सब्सक्रिप्शन",
    "trialUsed": "ट्रायल: {{used}}/{{total}} उपयोग किया",
    "trialStatus": "ट्रायल उपलब्ध",
    "activeStatus": "सक्रिय सब्सक्रिप्शन",
    "expiredStatus": "सब्सक्रिप्शन समाप्त",
    "unsubscribedStatus": "सब्सक्रिप्शन नहीं",
    "about": "जानकारी",
    "version": "संस्करण",
    "logout": "लॉग आउट",
    "logoutTitle": "लॉग आउट",
    "logoutConfirm": "क्या आप वाकई लॉग आउट करना चाहते हैं?",
    "noName": "कोई नाम सेट नहीं",
    "serverConnection": "सर्वर कनेक्शन",
    "serverUrl": "सर्वर URL",
    "serverEdit": "संपादित करें",
    "saveReconnect": "सहेजें और पुनः कनेक्ट करें",
    "resetDefault": "डिफ़ॉल्ट रीसेट करें",
    "invalidServerUrlTitle": "अमान्य सर्वर URL",
    "invalidServerUrlMessage": "कृपया मान्य http या https सर्वर URL दर्ज करें, जैसे https://example.com",
    "uiLanguageChangeFailed": "ऐप भाषा बदलने में विफल। कृपया पुनः प्रयास करें।",
    "serverLanguageChangeFailed": "चैट भाषा बदलने में विफल। कृपया पुनः प्रयास करें।",
    "timezoneChangeFailed": "समय क्षेत्र बदलने में विफल। कृपया पुनः प्रयास करें।",
    "autoSyncChangeFailed": "ऑटो-सिंक अपडेट करने में विफल। कृपया पुनः प्रयास करें।",
    "nameChangeFailed": "प्रदर्शित नाम अपडेट करने में विफल। कृपया पुनः प्रयास करें।",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "रिमाइंडर विवरण",
    "editTime": "समय संपादित करें",
    "rename": "नाम बदलें",
    "snooze": "स्नूज़ करें",
    "snooze15": "15 मिनट स्नूज़ करें",
    "pause": "रोकें",
    "pauseReminder": "रिमाइंडर रोकें",
    "resume": "जारी रखें",
    "resumeReminder": "रिमाइंडर जारी रखें",
    "skip": "अगला छोड़ें",
    "skipOccurrence": "इस बार छोड़ें",
    "syncGoogle": "Google से सिंक करें",
    "delete": "हटाएं",
    "deleteTitle": "रिमाइंडर हटाएं",
    "deleteConfirm": "यह रिमाइंडर स्थायी रूप से हट जाएगा।",
    "deleteRecurringTitle": "दोहराए जाने वाला रिमाइंडर हटाएं",
    "deleteRecurringMessage": "क्या आप इस बार छोड़ना चाहते हैं या पूरी श्रृंखला हटाना चाहते हैं?",
    "deleteThisOccurrence": "इस बार छोड़ें",
    "deleteEntireSeries": "पूरी श्रृंखला हटाएं",
    "done": "पूरा हुआ",
    "markDone": "पूरा हुआ चिह्नित करें",
    "undo": "पुनर्स्थापित करें",
    "undoPrompt": "फिर से सक्रिय करना है? अभी पुनर्स्थापित करें।",
    "recurring": "दोहराव",
    "nextRun": "अगली बार",
    "oneTime": "एक बार",
    "pending": "लंबित",
    "sent": "भेजा गया",
    "paused": "रोक दिया गया",
    "active": "सक्रिय",
    "snoozed": "स्नूज़ किया गया",
    "localTime": "आपके स्थानीय समय में दिखाया गया",
    "recurrence": "दोहराव",
    "created": "बनाया गया",
    "tags": "टैग",
    "fireCount": "बार सक्रिय हुआ",
    "actions": "क्रियाएं",
    "none": "कोई नहीं",
    "snoozeFailed": "रिमाइंडर स्नूज़ करने में विफल",
    "pauseFailed": "रिमाइंडर रोकने में विफल",
    "resumeFailed": "रिमाइंडर जारी करने में विफल",
    "skipFailed": "रिमाइंडर छोड़ने में विफल",
    "doneFailed": "रिमाइंडर पूरा चिह्नित करने में विफल",
    "undoFailed": "रिमाइंडर स्थिति पुनर्स्थापित करने में विफल",
    "deleteFailed": "रिमाइंडर हटाने में विफल",
    "rescheduleTitle": "पुनर्निर्धारित करें?",
    "rescheduleMsg": "यह रिमाइंडर मियाद समाप्त हो चुका है। क्या आप इसे पुनर्निर्धारित करना चाहेंगे?",
    "reschedule15": "15 मिनट में",
    "reschedule60": "1 घंटे में",
    "keepOverdue": "जैसा है वैसा रखें"
  },
  "onboarding": {
    "slide1Title": "FishMemory में आपका स्वागत है",
    "slide1Sub": "आपका व्यक्तिगत रिमाइंडर सहायक — WhatsApp द्वारा संचालित और आपकी जेब के लिए बनाया गया।",
    "slide2Title": "सहज चैट करें",
    "slide2Sub": "रिमाइंडर ऐसे टाइप करें जैसे आप सोचते हैं: \"मुझे कल 3 बजे माँ को कॉल करने की याद दिलाओ\" — बाकी हम संभालेंगे।",
    "slide3Title": "कुछ भी न चूकें",
    "slide3Sub": "समय पर सूचनाएं पाएं, टैग से व्यवस्थित करें, और महत्वपूर्ण चीजों पर नजर रखें।",
    "getStarted": "शुरू करें",
    "next": "अगला",
    "firstReminderTitle": "अपना पहला रिमाइंडर बनाएं!",
    "firstReminderHint": "कुछ इस तरह टाइप करें:",
    "firstReminderExample": "मुझे कल सुबह 9 बजे पानी पीने की याद दिलाओ",
    "gotIt": "समझ गया!",
    "notifRationaleTitle": "समय पर रहें",
    "notifRationaleBody": "FishMemory को समय पर याद दिलाने के लिए सूचनाओं की जरूरत होती है। आपको केवल आपके बनाए रिमाइंडर की सूचनाएं मिलेंगी।",
    "notifRationaleAllow": "सूचनाएं सक्षम करें",
    "notifRationaleLater": "शायद बाद में",
    "swipeHint": "त्वरित क्रियाओं के लिए दाईं ओर स्वाइप करें →",
    "calendarDragHint": "विस्तार के लिए खींचें ↕"
  }
}
